/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Cover_Letters_Resume_MasterInputs */

const en_cover_letters_resume_master = /** @type {(inputs: Cover_Letters_Resume_MasterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (Master)`)
};

const de_cover_letters_resume_master = /** @type {(inputs: Cover_Letters_Resume_MasterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (Vorlage)`)
};

const fr_cover_letters_resume_master = /** @type {(inputs: Cover_Letters_Resume_MasterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (Principal)`)
};

const es_cover_letters_resume_master = /** @type {(inputs: Cover_Letters_Resume_MasterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (Principal)`)
};

const it_cover_letters_resume_master = /** @type {(inputs: Cover_Letters_Resume_MasterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (Principale)`)
};

const nl_cover_letters_resume_master = /** @type {(inputs: Cover_Letters_Resume_MasterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (Sjabloon)`)
};

const pl_cover_letters_resume_master = /** @type {(inputs: Cover_Letters_Resume_MasterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (Główne)`)
};

const fi_cover_letters_resume_master = /** @type {(inputs: Cover_Letters_Resume_MasterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (Pääversio)`)
};

const da_cover_letters_resume_master = /** @type {(inputs: Cover_Letters_Resume_MasterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (Skabelon)`)
};

const sv_cover_letters_resume_master = /** @type {(inputs: Cover_Letters_Resume_MasterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (Huvudversion)`)
};

/**
* | output |
* | --- |
* | "{title} (Master)" |
*
* @param {Cover_Letters_Resume_MasterInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_resume_master = /** @type {((inputs: Cover_Letters_Resume_MasterInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Resume_MasterInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_resume_master(inputs)
	if (locale === "fr") return fr_cover_letters_resume_master(inputs)
	if (locale === "es") return es_cover_letters_resume_master(inputs)
	if (locale === "it") return it_cover_letters_resume_master(inputs)
	if (locale === "nl") return nl_cover_letters_resume_master(inputs)
	if (locale === "pl") return pl_cover_letters_resume_master(inputs)
	if (locale === "fi") return fi_cover_letters_resume_master(inputs)
	if (locale === "da") return da_cover_letters_resume_master(inputs)
	if (locale === "sv") return sv_cover_letters_resume_master(inputs)
	return en_cover_letters_resume_master(inputs)
});